import {Fragment} from "react";
import * as React from "react";
import "./sikhona_loading_component.css";

export default class SikhonaLoadingComponent extends React.Component {

    render() {
        let style = this.props.style ? this.props.style : {};
        return <Fragment>
            <div className={"outer-container"} style={style}>
            <div className={"motion"}>
                <img className={"logo-img"} src={"/images/wash_out_logo_S.png"}  alt={""} />
                <div className={"circle"} />
            </div>
            </div>
        </Fragment>
    }
}